const normalize = (value) => String(value ?? '').toLowerCase().replace(/\s+/g, ' ').trim();

export function filterPlansByTeam(plans, query) {
  const needle = normalize(query);
  if (!needle) return plans;
  return (plans || []).filter((plan) => {
    const team = plan.teamId;
    return !!team && [team.name, team.username].some((field) => normalize(field).includes(needle));
  });
}
